import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RootCategoriesDataSource } from './rootcategories-datasource';
import { RootcategoriesService } from './rootcategories.service';
import { CategoriesItem } from '../categories/categories.model';
import { NodeService } from '../../services/node-service/node-service.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root-categories',
  templateUrl: './rootcategories.component.html',
  styleUrls: ['./rootcategories.component.css'],
  standalone: false,
})
export class RootCategoriesComponent implements OnInit, OnDestroy {
  dataRootCategories!: RootCategoriesDataSource;
  displayedColumns = ['id', 'nombre', 'pois_count', 'fuente', 'red', 'created_at', 'actions'];
  loadedData!: CategoriesItem[];
  subscription!: Subscription;

  constructor(
    public route: ActivatedRoute,
    private nodeService: NodeService,
    private rootCategoriesService: RootcategoriesService
  ) {}

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.subscription = this.rootCategoriesService.loadCategories().subscribe({
      next: ({ body }) => {
        if (body.label === 'parent') {
          this.dataRootCategories = new RootCategoriesDataSource(body.body);
          this.loadedData = body.body;
          this.nodeService.setCategories(body.body);
        }
      },
      error: () => {
        this.rootCategoriesService.openSnacBar('Ha ocurrido un error');
      },
    });
  }
}
